import { ComponentType } from 'react';
import { SingleDetail } from '../../../../../../components/atoms/SingleDetail';
import { FormDurationInput } from '../../../../../../components/molecules/FormComponents';
import { useFormContext } from 'react-hook-form';
import { InputLabel } from '@nexelem/inputs';
import { AddToPlanFormSchema } from './getAddToPlanFormSchema';

type DurationInputProps = {
  duration?: string;
  required?: boolean;
  type: 'production' | 'retooling';
  title: string;
  Icon: ComponentType<{ className?: string }>;
  isEditable?: boolean;
};

const DURATION_FIELD_MAPPING = {
  production: {
    hasCustom: 'hasCustomProductionDuration',
    override: 'overrideProductionDuration',
  },
  retooling: {
    hasCustom: 'hasCustomRetoolingDuration',
    override: 'overrideRetoolingDuration',
  },
} as const;

export const DurationInput = ({ duration, required, type, title, Icon, isEditable }: DurationInputProps) => {
  const { watch, setValue } = useFormContext<AddToPlanFormSchema>();

  const fieldMapping = DURATION_FIELD_MAPPING[type];
  const hasCustomDurationField = fieldMapping.hasCustom;
  const overrideDurationField = fieldMapping.override;

  const setHasCustomDuration = () => {
    setValue(hasCustomDurationField, true);
  };

  const hasCustomDuration = watch(hasCustomDurationField);

  return (
    <>
      {!hasCustomDuration && (
        <SingleDetail
          isEditable={isEditable}
          title={<InputLabel label={title} required={required} />}
          content={
            <div className="flex items-center gap-2">
              <Icon className="!h-6 w-6" />
              {duration}
            </div>
          }
          onClick={setHasCustomDuration}
        />
      )}
      {hasCustomDuration && <FormDurationInput label={title} name={overrideDurationField} required={required} />}
    </>
  );
};
